export const dirSettings = fbSettings => ({
  defaultCountry: fbSettings.default_country || {},
  defaultRegion: fbSettings.default_region || {},
  defaultDate: fbSettings.default_date || {},
  defaultCountryCode: fbSettings.default_country_code || {},
  defaultBasicsVisible: fbSettings.default_basicsVisible || false,
  defaultPhoneVisible: fbSettings.default_phoneVisible || false,
  defaultAddressVisible: fbSettings.default_addressVisible || false,
});
